/**
 * useTaxClients — lista todos los tax_clients para el selector del
 * frontend admin (módulo plantillas PDF, dashboard, etc.).
 *
 * Cache 5min — la lista no cambia con frecuencia.
 */

import { useQuery } from '@tanstack/react-query'

import { taxClientsApi, type ListResponse, type TaxClient } from '@/lib/api-pdf-templates'

const QUERY_KEY = ['admin', 'tax-clients'] as const

export function useTaxClients() {
  return useQuery<ListResponse<TaxClient>>({
    queryKey: QUERY_KEY,
    queryFn: () => taxClientsApi.list(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: (failureCount, err: unknown) => {
      const status = (err as { response?: { status?: number } })?.response?.status
      if (status === 401 || status === 403) return false
      return failureCount < 1
    },
  })
}
